import { Operation } from './Operation'

export enum IncidentType {
    RESPONSE_TIME = 'transaction-walltime',
    ERROR_RATE = 'error-rate',
    TRANSACTION_FAILURE_RATE = 'transaction-failure-rate',
    ERROR_GROUP = 'error_group',
    WEEKLY_REPORT = 'weekly_report',
    RELEASE_INTEGRATION = 'release',
    TRACEPOINT = 'trace-boost',
    SLOW_SQL = 'slow-sql',
    RESPONSE_TIME_DEVIATION = 'response-time-deviation',
    MISSING_DATA = 'missing-data',
}

export interface Incident {
    id: number
    type: IncidentType
    startDate: string
    endDate: string | null
    alerts: Array<BaseAlert | TransactionFailureRateAlert>
    transaction: Operation | null
    service: string
    environment: string
    duration: number
    threshold: string
    lastValue: string
}

export interface TransactionFailureRateIncident extends Incident {
    alerts: TransactionFailureRateAlert[]
}

export interface Alert {
    date: string
    value: string
    threshold: string
    severity: string
}

interface BaseAlert extends Alert {
    data: string
}

interface TransactionFailureRateAlert extends Alert {
    data: {
        errors: {
            total: number
            entries: Array<{
                errorRate: number
                id: number
                name: string
            }>
        }
    }
}

export const isAnyFailureRateIncident = (incident: Incident) => {
    return incident.type === IncidentType.TRANSACTION_FAILURE_RATE || incident.type === IncidentType.ERROR_RATE
}
